import styled from 'styled-components';

export const StyledItem = styled.div`
  background-color: var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px;
  border: 1px solid #f4f4f4;
  margin-bottom: 12px;

  div {
    margin: 0;
  }
`;
